import api from './api';
import { listaUsuarios } from './cadastroUsuario';

export const getListaUsuario = async () => {
  const payload = { registerNumber: '1000', pageNumber: '1' };
  try {
    const usuarios = await listaUsuarios(payload);
    return usuarios;
  } catch (error) {
    return { error };
  }
};

export const getListaMatriz = async () => {
  try {
    const { data } = await api.get('/Matriz/list');
    return data;
  } catch (error) {
    return { error };
  }
};

export const getFiltrarAtendimento = async params => {
  try {
    const response = await api.get(`/HistoricoSolicitacao/list?${params}`);
    return response;
  } catch (error) {
    return { error };
  }
};

export const getSolicitacaoDetalahada = async params => {
  try {
    const { idSolicitacao } = params;
    const data = await api.get(
      `/SolicitacaoAtendimento/?idSolicitacao=${idSolicitacao}`
    );
    return data;
  } catch (error) {
    return { error };
  }
};

export const postCancelarSolicitacao = async param => {
  try {
    const { idSolicitacao } = param;
    const data = await api.put(
      `/SolicitacaoConsulta/Cancelar/${idSolicitacao}`
    );
    return data;
  } catch (error) {
    return { error: true, data: error };
  }
};

export const putAtualizarConsultas = async idSolicitacao => {
  try {
    return await api.put(
      `/SolicitacaoConsulta/EnviarConsultas/${idSolicitacao}`
    );
  } catch (error) {
    return { error };
  }
};

export const putSolicitarRetornoTransSat = async idConsultaSolicitacao => {
  try {
    return await api.put(
      `/transsat/solicitar-retorno/${idConsultaSolicitacao}`
    );
  } catch (error) {
    return { error };
  }
};

export const getListaStatusSolicitacao = async () => {
  try {
    const data = await api.get('/SolicitacaoConsulta/list-status-solicitacao');
    return data;
  } catch (error) {
    return { error };
  }
};

export const getListaStatusAtendimento = async () => {
  try {
    const data = await api.get('/Atendimento/list-status-atendimento');
    return data;
  } catch (error) {
    return { error };
  }
};
